import PropTypes from 'prop-types'
import { getContext } from 'recompose'

const withIsWhiteTheme = getContext({
  isWhiteTheme: PropTypes.bool.isRequired,
  isMarketing: PropTypes.bool.isRequired
})

export default withIsWhiteTheme
